(ns ui.components.link.view
  (:require
    [common.util :as cu]
    [re-frame.core :as rf]
    [ui.util :as uu]))

(defn preview
  [{:keys [url label target]}]
  [:a
   {:href   "#_"
    :class  "text-base-light-text-accent hover:text-underline hover:text-base-light-text-accent"
    :target (or target "_blank")}
   (if-not (cu/blank-value? label)
     label
     url)])

(defn view
  [{:keys [url class label target on-click]}]
  [:a
   {:href     url
    :on-click on-click
    :class    (uu/cm "text-base-light-text-accent hover:text-underline hover:text-base-light-text-accent" class)
    :target   (or target "_blank")}
   (if-not (cu/blank-value? label)
     label
     url)])

(defn side-nav-link
  [{:keys [dom-id active? on-click href]} & children]
  (into [:a
         {:class    (str "px-1 md:px-4 py-2 text-center md:text-start text-nowrap md:text-wrap text-base-light-text hover:text-base-light-text-accent border-0 md:border-l-2 border-solid cursor-pointer "
                         (if active?
                           "text-base-light-text-accent border-0 border-b-2 md:border-b-0 md:border-l-2 border-solid border-base-light-border-accent"
                           "border-transparent"))
          :on-click on-click
          :href     href
          :id       dom-id}]
        children))

(defn side-link-tab
  [{:keys [active-tab tab-key tab-event-vec label]}]
  [side-nav-link
   {:active?  (= tab-key active-tab)
    :on-click (fn [_]
                (rf/dispatch (into tab-event-vec [tab-key])))}
   label])
